import React, { useState } from "react";
import NotificationAboutCookie from "ComponentsUI/NotificationAboutCookie";
import { generateUrl } from "Services/withDefaultParams";
import { withRouter } from "react-router-dom";

import Routes from "Configs/routes";
const Cookies = require("js-cookie");

const arrayNotRegionUrl = [
	"providers",
	"operatory",
	"exclusive",
	"news",
	"reviews",
	"compare",
	"actions",
	"rate",
	"orders",
	"business",
	"rating",
	"address",
	"terms-of-use",
	"personal-data",
	"feedback",
	"about",
	"contact-feedback",
	"ratesmobile",
	"sim-karty",
	"nomera",
	"select-region",
	"rates",
];

const CookieNotificationHOCContainer = (props) => {
	const allowClose = Cookies.get("closeNotificationAboutCookie");
	let firstURL = Cookies.get("firstURL");
	let currentURL = props.location.pathname;
	let date = new Date();
	date.setTime(date.getTime() + 60 * 60 * 24 * 30 * 1000);
	if (!firstURL) {
		Cookies.set("firstURL", false, { expires: date });
		firstURL = Cookies.get("firstURL");
	}

	const [isClosed, setIsClosed] = useState(allowClose);

	const onClose = () => {
		Cookies.set("closeNotificationAboutCookie", true, { expires: date });
		setIsClosed(true);
	};

	if (!isClosed) {
		let regionUrl = props.match.params.regionUrl;

		let regionUrlReal = arrayNotRegionUrl.indexOf(regionUrl) >= 0 ? "" : regionUrl;

		let link = generateUrl(Routes.PersonalData.route, {
			regionUrl: regionUrlReal,
		});
		if (firstURL == "false") {
			Cookies.set("firstURL", currentURL, { expires: date });
			return <NotificationAboutCookie onClose={onClose} link={link} text={props.text} />;
		} else {
			return null;
		}
	} else {
		return null;
	}
};

export default withRouter(CookieNotificationHOCContainer);
